import {ComboBox, ComboBoxChangeEvent, ComboBoxFilterChangeEvent, ComboBoxProps} from "@progress/kendo-react-dropdowns";
import {ApiResponseDto, DropDownListItem} from "../../utils/Models";
import {useCallback, useEffect, useRef, useState} from "react";
import axios from "axios";

export default function FlintRemoteDataComboBox<T extends DropDownListItem>(props: FlintRemoteDataComboBoxProps<T>) {
    const pendingRequest = useRef<any>(undefined);
    const requestStarted = useRef(false);
    const [data, setData] = useState<T[]>([]);

    //const skipRef = useRef(0);

    const {
        baseUrl,
        onChange,
        onFilterChange: ofc,
        dataItemKey = "Id",
        textField = "Name",
        ...other
    } = props;

    const requestData = useCallback((filter: string) => {
        if (requestStarted.current) {
            clearTimeout(pendingRequest.current);
            pendingRequest.current = setTimeout(() => {
                requestData(filter);
            }, 50);
            return;
        }

        requestStarted.current = true;
        axios.get<ApiResponseDto<T[]>>(baseUrl, {params: {"filter": filter}})
            .then((response) => {
                const items = response.data.Result;
                if (!items || !(items instanceof Array<T>))
                    return;
                setData(items);
                requestStarted.current = false;
            }).catch((error) => {
            console.error(error);
        });
    }, []);

    function handleOnChange(e: ComboBoxChangeEvent) {
        if (props.onChange)
            props.onChange(e);
        props.onItemSelected(e.value);
    }

    const onFilterChange = useCallback((event: ComboBoxFilterChangeEvent) => {
        const filter = event.filter.value;
        requestData(filter);
    }, []);
    const emptyItem: DropDownListItem = {Name: 'loading ...', Id: 0};
    const pageSize = 50;
    const loadingData: DropDownListItem[] = [];
    while (loadingData.length < pageSize) {
        loadingData.push({...emptyItem});
    }
    return <ComboBox
        allowCustom={true}
        filterable={true}
        data={data}
        dataItemKey={dataItemKey}
        textField={textField}
        onChange={handleOnChange}
        onFilterChange={onFilterChange}
        {...other}
    />
}

export interface FlintRemoteDataComboBoxProps<T extends DropDownListItem> extends ComboBoxProps {
    baseUrl: string;
    onItemSelected: (item: T) => void;
}